window.evdnceApplySwatchVisibility = function(g) {
  var gender = g || sessionStorage.getItem('evdnce_gender');

  // PDP colour swatches (evp-swatch)
  document.querySelectorAll('.evp-swatch').forEach(function(swatch) {
    if (gender === 'women') {
      if (swatch.getAttribute('data-has-women') === 'true') {
        swatch.classList.remove('evdnce-no-women');
      } else {
        swatch.classList.add('evdnce-no-women');
      }
    } else {
      swatch.classList.remove('evdnce-no-women');
    }
  });

  // PLP + PDP card swatches (evdnce-card-swatch)
  document.querySelectorAll('.evdnce-card-swatch').forEach(function(swatch) {
    if (gender === 'women') {
      if (swatch.hasAttribute('data-image-women')) {
        swatch.classList.remove('evdnce-no-women');
      } else {
        swatch.classList.add('evdnce-no-women');
      }
    } else {
      swatch.classList.remove('evdnce-no-women');
    }
  });

  // Hide men-only/women-only cards (View the Range, Style With etc)
  document.querySelectorAll('product-card[data-product-gender]').forEach(function(card) {
    var pg = card.getAttribute('data-product-gender');
    var hide = (gender === 'women' && pg === 'men') || (gender === 'men' && pg === 'women');

    // Hide the card itself
    card.style.display = hide ? 'none' : '';

    // Walk up and hide any swiper-slide parent (both desktop + mobile swiper)
    var el = card.parentElement;
    while (el) {
      if (el.classList && el.classList.contains('swiper-slide')) {
        el.style.display = hide ? 'none' : '';
        break;
      }
      el = el.parentElement;
    }
  });

  // Sticky ATC image - swap to women's image if available
  var stickyImg = document.querySelector('.product__sticky-cart--info .media img');
  if (stickyImg && gender === 'women') {
    var womenSlide = document.querySelector('.swiper--product-gallery .swiper-slide:not(.evdnce-gender-hidden) img');
    if (womenSlide && womenSlide.src) {
      stickyImg.src = womenSlide.src;
      stickyImg.srcset = '';
    }
  }

  // Update all swipers after hiding slides
  setTimeout(function() {
    document.querySelectorAll('.swiper').forEach(function(el) {
      if (el.swiper) {
        el.swiper.update();
      }
    });
  }, 50);
};

// Run on load
(function() {
  function init() {
    if (typeof window.evdnceApplySwatchVisibility === 'function') {
      window.evdnceApplySwatchVisibility();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 500);
  setTimeout(init, 1500);
})();

/* ===================================================================
   EVDNCE product-card colour swatches — image-swap fix (JS only)
   Added 15.07.26 (preview: "15.07.26 - Colour Swatch Bug Fix")

   NO visual change to the swatches themselves. Fixes swatch behaviour:

   Problems (in global.js + theme):
   • Colour images weren't preloaded -> slow first switch.
   • The card has a HOVER image layered over the main image. Only the
     main image was being swapped, so the new colour was hidden behind
     the hover image until you moved the mouse off — and re-appeared as
     the old colour when you hovered again.
   • A leftover "mouseout" handler reverted the image on cursor-leave.

   Fix:
   • Preload every colour image while idle -> instant.
   • On click, swap BOTH the main image AND the hover image to the
     chosen colour and force them visible, so the change shows instantly
     whether or not the card is hovered, and LOCK the selection.
   • Intercept the old hover/mouseout/click handlers (capture phase,
     swatch targets only) so nothing reverts your choice.
   • Clicking still points the card's links at that colour's product.
   =================================================================== */
(function () {
  if (window.__evdnceSwatchFix) return;
  window.__evdnceSwatchFix = true;

  function cardOf(el) { return el && el.closest ? el.closest('.product-card, product-card') : null; }
  function mainImg(card) {
    if (!card) return null;
    return card.querySelector('.product-card__media img:not(.hover-img)') ||
           card.querySelector('.product-card__media img') ||
           card.querySelector('img');
  }
  function hoverImg(card) { return card ? card.querySelector('.product-card__media img.hover-img') : null; }

  var preloaded = Object.create(null);
  function preload(u) { if (!u || preloaded[u]) return; preloaded[u] = true; var i = new Image(); i.decoding = 'async'; i.src = u; }

  var locked = new WeakMap();   /* card -> swatch the user clicked */
  var dflt   = new WeakMap();   /* card -> swatch active on load   */
  function rememberDefault(card) { if (!dflt.has(card)) dflt.set(card, card.querySelector('.evdnce-card-swatch.is-active') || null); }
  function setActive(card, sw) { card.querySelectorAll('.evdnce-card-swatch').forEach(function (s) { s.classList.toggle('is-active', s === sw); }); }

  function setImg(im, u) {
    if (!im || !u) return;
    if (!im.dataset.originalSrc) im.dataset.originalSrc = im.currentSrc || im.src;
    im.setAttribute('src', u);
    im.setAttribute('srcset', u);
    im.setAttribute('sizes', '100vw');
    im.removeAttribute('loading');
    im.classList.remove('lazy');   /* skip the fade-in wait */
    im.style.opacity = '1';        /* ensure it's visible immediately */
  }
  function revertImg(im) {
    if (!im || !im.dataset.originalSrc) return;
    im.setAttribute('src', im.dataset.originalSrc);
    im.removeAttribute('srcset');
  }

  /* Swap BOTH images so the colour is visible in resting AND hover state */
  function applyColour(card, u) { setImg(mainImg(card), u); setImg(hoverImg(card), u); }

  function restore(card) {
    var l = locked.get(card);
    if (l) { applyColour(card, l.getAttribute('data-image')); setActive(card, l); return; }
    revertImg(mainImg(card)); revertImg(hoverImg(card));
    setActive(card, dflt.get(card) || null);
  }

  function preloadAll() { document.querySelectorAll('.evdnce-card-swatch').forEach(function (s) { preload(s.getAttribute('data-image')); }); }
  if ('requestIdleCallback' in window) { requestIdleCallback(preloadAll, { timeout: 2500 }); } else { setTimeout(preloadAll, 1200); }

  function onOver(e) {
    var sw = e.target && e.target.closest ? e.target.closest('.evdnce-card-swatch') : null;
    if (!sw) return;
    e.stopImmediatePropagation();
    var card = cardOf(sw); if (!card) return;
    rememberDefault(card);
    preload(sw.getAttribute('data-image'));
    applyColour(card, sw.getAttribute('data-image'));
    setActive(card, sw);
  }
  function onOut(e) {
    var sw = e.target && e.target.closest ? e.target.closest('.evdnce-card-swatch') : null;
    if (!sw) return;
    e.stopImmediatePropagation();
    var card = cardOf(sw); if (card) restore(card);
  }
  function onClick(e) {
    var sw = e.target && e.target.closest ? e.target.closest('.evdnce-card-swatch') : null;
    if (!sw) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var card = cardOf(sw); if (!card) return;
    rememberDefault(card);
    locked.set(card, sw);
    applyColour(card, sw.getAttribute('data-image'));
    setActive(card, sw);
    var url = sw.getAttribute('href');
    if (url) {
      card.querySelectorAll('a.product-card__link').forEach(function (a) { a.setAttribute('href', url); });
      var q = card.querySelector('[data-product-url]');
      if (q) q.setAttribute('data-product-url', url);
    }
  }
  function onPointerDown(e) {
    var sw = e.target && e.target.closest ? e.target.closest('.evdnce-card-swatch') : null;
    if (sw) preload(sw.getAttribute('data-image'));
  }

  document.addEventListener('mouseover',   onOver,        true);
  document.addEventListener('mouseout',    onOut,         true);
  document.addEventListener('click',       onClick,       true);
  document.addEventListener('pointerdown', onPointerDown, true);
})();
